import { DefaultSite, DefaultZone, RgCreate } from "@project-rouge/rg-core";
function CreateSite({ sitePoly, zonePolys, dataset }) {
	const site = RgCreate({ ...DefaultSite }, dataset.rvData);
	site.data.polygon = sitePoly.slice();
	site.data.dataset = dataset.id;
	for (const zonePoly of zonePolys) {
		const zone = RgCreate({ ...DefaultZone }, dataset.rvData);
		zone.data.polygons = [zonePoly.slice()];
		zone.data.realPoly = zonePoly.slice();
		site.children.push(zone);
	}
	return site;
}
export { CreateSite };

//# sourceMappingURL=index188.js.map